import styles from "../styles/RichText.module.css";

export const Heading = ({ children }) => <h3 className={styles.heading}>{children}</h3>;

export const P = ({ children }) => <p className={styles.para}>{children}</p>;

export const Footnote = ({ children }) => <p className={styles.footnote}>{children}</p>;

export const Quote = ({ children }) => <blockquote className={styles.quote}>{children}</blockquote>;
